// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__1TCzF","projectDescription":"projectDescription__4wZwR"};


//////////////////
// WEBPACK FOOTER
// ./components/main/styles.styl
// module id = C9pf
// module chunks = 0